module.exports = __webpack_public_path__ + "img/page-header@3x.02f4d794.png";